import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { useGetData } from "..";
import { ENDPOINTS } from "../../constants/endpoints";
import lnMap from "../../languages/language-maps/shared-lang-map";
import {
  getCompanies,
  getCompaniesByQuery,
  sortCompanies,
} from "../../mock/services";

function useAllCompaniesLogic() {
  /*  const { data, getData } = useGetData(); */
  const [data, setData] = useState(null);
  const search = useLocation().search;
  const where = new URLSearchParams(search).get("where");
  const from = new URLSearchParams(search).get("from");
  const query = new URLSearchParams(search).get("q");

  const tabs = useMemo(
    () => [
      {
        name: lnMap.highlights,
      },
      { name: lnMap.fast_delivery },
      { name: lnMap.new_companies },
    ],
    []
  );

  const handleSortingItemClick = (item) => {
    item.value && setData(sortCompanies(data?.hits?.data, item.value));
  };

  useEffect(() => {
    if (where && from && !query) {
      return setData(getCompaniesByQuery({ where, from }));
    }
    if (!query) setData(getCompanies());
  }, [from, where, query]);

  useEffect(() => {
    if (!where && !from && query) {
      setData(getCompaniesByQuery({ keyword: query }));
    }
  }, [query, from, where]);
  return { data, tabs, handleSortingItemClick, where, from };
}

export default useAllCompaniesLogic;
